<script setup lang="ts">
import AppHeaderBar from '@/components/default-customer/app-header-bar.vue'
import AppHeaderBarTG from '@/components/tg/app-header-bar.vue'
import AppHeaderBarSH from '@/components/sh/app-header-bar.vue'
import KpFooter from '@/components/default-customer/app-footer.vue'
import KpFooterTG from '@/components/tg/app-footer.vue'
import KpFooterSH from '@/components/sh/app-footer.vue'
import UserMenu from '@/components/user-menu-btn.vue'
import NeueMitteilungenBtn from '@/components/mitteilung/neue-mitteilungen-btn.vue'
import Welcome from '@/components/welcome-dlg.vue'
import HelpDialog from '@/components/help-dlg.vue'
import { useBrowserSessionValue } from '@/helpers/browser_session'
import { onMounted, ref, type Ref } from 'vue'
import { useAuthUser, useGlobals } from '@/helpers/globals'
import { useI18n } from 'vue-i18n'
import type { Mitteilung } from '@/models/Mitteilung'
import { useRoute, useRouter } from 'vue-router'
import { logout } from '@/helpers/auth'
import { useUnreadMessages } from '@/composables/unreadMessages'
import { updateTeamRequests, useTeamRequests } from '@/composables/team'

const router = useRouter()
const route = useRoute()
const drawer = ref(false)
const welcomeDlg = ref(false)
const profileMsg: Ref<string | null> = ref(null)
const showHelp = ref(false)
const loading = ref(false)
const authUser = useAuthUser()
const customer = useGlobals().customer
const { t } = useI18n()
const teamRequests = useTeamRequests()
const mitteilungen = useUnreadMessages()

onMounted(async () => {
    const noMsg = useBrowserSessionValue('noWelcomeDlg_' + authUser?.id, 'false')
    if (!noMsg.value || noMsg.value === 'false') {
        if (!authUser?.profileComplete()) {
            profileMsg.value = t('profile_update_msg')
            welcomeDlg.value = true
        }
    }
    updateTeamRequests()
})

function onMitteilungclick(mitteilung: Mitteilung) {
    if (mitteilung && mitteilung.gesuch_nummer) {
        router.push(`/gesuche/${mitteilung.gesuch_nummer}/nachrichten`).catch(() => {})
    }
}
</script>

<template>
    <v-app id="auth-app">
        <Welcome
            :loading="loading"
            :model-value="welcomeDlg"
            :msg="profileMsg"
            @close="welcomeDlg = false"
        />
        <HelpDialog v-model:value="showHelp" @close="showHelp = false"></HelpDialog>

        <template v-if="customer === 'tg'">
            <AppHeaderBarTG
                :teamrequests="teamRequests"
                @navbtn="drawer = !drawer"
                :mitteilungen="mitteilungen"
                @show_help="showHelp = true"
            >
            </AppHeaderBarTG
        ></template>
        <AppHeaderBarSH
            v-else-if="customer === 'sh'"
            :teamrequests="teamRequests"
            @navbtn="drawer = !drawer"
            :mitteilungen="mitteilungen"
            @show_help="showHelp = true"
        >
        </AppHeaderBarSH>
        <AppHeaderBar v-else app :teamrequests="teamRequests" @navbtn="drawer = !drawer">
            <v-spacer />
            <NeueMitteilungenBtn
                v-if="mitteilungen && mitteilungen.length > 0"
                @mitteilungclick="onMitteilungclick"
            />
            <UserMenu
                :benutzer="authUser"
                @logout="logout"
                @profil="
                    route.path != '/adressen/profil' ? router.push('/adressen/profil') : () => {}
                "
            />
            <v-btn text @click="showHelp = true">
                <span class="mr-2 d-none d-md-inline">
                    {{ $t('hilfe_kontakt') }}
                </span>
                <v-icon color="grey darken-1 d-md-inline">fas fa-question</v-icon>
            </v-btn>
        </AppHeaderBar>
        <v-main class="white">
            <router-view />
        </v-main>
        <KpFooter v-if="customer === 'default'" app :loading="loading" />
        <KpFooterTG v-if="customer === 'tg'" app :loading="loading" />
        <KpFooterSH v-if="customer === 'sh'" app :loading="loading" />
    </v-app>
</template>
